// Utilidades para ordenar/agrupar listas de emplazamientos.
//
// Regla de negocio (feb 2026):
//  - Las listas se agrupan visualmente por provincia (A→Z, "Sin provincia" al final).
//  - Dentro de cada provincia se ordenan por el número del código TOTEM (alt_code
//    tipo SPA-1234) de menor a mayor. Si no hay alt_code se cae al code interno.

const extractNumber = (str) => {
  if (!str) return null;
  const m = String(str).match(/(\d+)/g);
  if (!m || m.length === 0) return null;
  // Cogemos el último número (SPA-1234 → 1234; A-45-B → 45).
  return parseInt(m[m.length - 1], 10);
};

export const siteNumber = (s) => {
  if (!s) return null;
  return extractNumber(s.alt_code) ?? extractNumber(s.code) ?? extractNumber(s.name);
};

export const siteProvince = (s) => {
  if (!s) return 'Sin provincia';
  // Formas típicas: s.province directo o anidado en s.site.province.
  const p = s.province ?? s.site?.province ?? '';
  const clean = String(p).trim();
  return clean || 'Sin provincia';
};

// Ordena in-place lógicamente (devuelve nuevo array) por alt_code numérico asc,
// dejando los sin número al final.
export const sortByAltCode = (items) => {
  return [...(items || [])].sort((a, b) => {
    const na = siteNumber(a);
    const nb = siteNumber(b);
    if (na == null && nb == null) return 0;
    if (na == null) return 1;
    if (nb == null) return -1;
    return na - nb;
  });
};

// Devuelve [{ province, items: [...ordenados por alt_code asc] }], provincias A→Z.
export const groupByProvince = (items) => {
  const map = new Map();
  (items || []).forEach((it) => {
    const p = siteProvince(it);
    if (!map.has(p)) map.set(p, []);
    map.get(p).push(it);
  });
  const groups = Array.from(map.entries()).map(([province, arr]) => ({
    province,
    items: sortByAltCode(arr),
  }));
  groups.sort((a, b) => {
    if (a.province === 'Sin provincia') return 1;
    if (b.province === 'Sin provincia') return -1;
    return a.province.localeCompare(b.province, 'es');
  });
  return groups;
};
